import type { ImageInterfaceFragment, SeoFragment } from '~/types/graphql-operations'
import { decode } from 'html-entities'

interface Entry {
  title?: string
  description?: string
  excerpt?: string
  seo?: SeoFragment
  thumbImage?: (ImageInterfaceFragment | null)[]
}

function getFirstThumbImage(entry: Entry): string | undefined {
  if (!entry.thumbImage)
    return undefined
  return Array.isArray(entry.thumbImage) && entry.thumbImage.length > 0
    ? entry.thumbImage[0]?.url
    : undefined
}

function getImageUrl(imageUrl?: string): string | null {
  const nuxtImg = useImage()
  return imageUrl ? nuxtImg(imageUrl, { width: 1200, height: 630, quality: 80 }) : null
}

function getFallbackImage() {
  const siteConfig = useSiteConfig()
  const runtimeConfig = useRuntimeConfig()
  const siteHandle = useSiteHandle()
  const baseUrl = ((siteConfig.url || runtimeConfig.public.baseUrl) as string).replace(/\/$/, '')

  // public/og-image-<siteHandle>.jpg (e.g. og-image-no-j.jpg, og-image-dr-alexis-granite.jpg)
  return getImageUrl(`${baseUrl}/og-image-${siteHandle.value}.jpg`)
}

export default (entry: Entry) => {
  const thumbImageUrl = getFirstThumbImage(entry)
  const facebookImageUrl = entry.seo?.social?.facebook?.image?.url
  const twitterImageUrl = entry.seo?.social?.twitter?.image?.url

  let ogFallback
  if (!thumbImageUrl && !facebookImageUrl && !twitterImageUrl) {
    ogFallback = getFallbackImage()
  }

  const primaryImageUrl = thumbImageUrl || facebookImageUrl || twitterImageUrl
  const processedImageUrl = getImageUrl(primaryImageUrl)

  const title = decode(entry.seo?.title) || decode(entry.title)
  const defaultDescription = entry.seo?.description || entry.excerpt || ''

  useSeoMeta({
    title,
    description: defaultDescription,

    // twitterDescription: entry.seo?.social?.twitter?.description || defaultDescription,
    // twitterImage: getImageUrl(twitterImageUrl) || processedImageUrl || ogFallback,

    ogDescription: entry.seo?.social?.facebook?.description || defaultDescription,
    ogImage: getImageUrl(facebookImageUrl) || processedImageUrl || ogFallback,
  })
}
